import axios from 'utils/axios';
import { createAsyncThunk } from '@reduxjs/toolkit';

const urls = {
  allCustomers: 'customer/all'
};

export const getAllCustomerApi = createAsyncThunk('serviceplug/getAllCustomer', async (params, thunkApi) => {
  try {
    const response = await axios.get(urls.allCustomers);
    if (response.data?.result) {
      return response.data.result;
    }
    return thunkApi.rejectWithValue('Something went wrong with this');
  } catch (error) {
    return thunkApi.rejectWithValue(error);
  }
});
